import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Spinner from '../Spinner';
import api from '../../api/axiosInstance';
function ErrorLogs() {
    const [errorLogs, setErrorLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchErrorLogs = async () => {
            try {
                const response = await api.get('/Administration/ViewErrorLogs');
                setErrorLogs(response.data);
            } catch (error) {
                console.error("Error fetching ErrorLogs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchErrorLogs();
    }, []);

    useEffect(() => {
        if (!loading) {
            if (window.$) {
                window.$('#example1').DataTable({
                    responsive: true,
                    autoWidth: false,
                    searching: true,
                    ordering: true,
                    pageLength: 10,
                    lengthChange: false,
                    paging: true,
                    info: true,
                });
            }
        }
    }, [loading]);

    const deleteErrorLog = async (id) => {
        $.confirm({
            title: 'Confirm Deletion',
            content: 'Do you really want to delete this?',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () {
                        // Do nothing on cancel
                    }
                },
                confirm: {
                    text: 'Yes, delete it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            const response = await api.delete(`/Administration/DeleteErrorLog/${id}`);
                            // setErrorLogs((prevLogs) => prevLogs.filter(log => log.id !== id));
                            // Success alert
                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Refresh the category data after deletion
                                            api.get(`/Administration/ViewErrorLogs`)
                                                .then(fetchResponse => {
                                                    setErrorLogs(fetchResponse.data);
                                                });
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                            if (error.response && error.response.status === 409) {
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                            } else {
                                $.alert({
                                    title: 'Error!',
                                    content: 'Error deleting ErrorLogs',
                                    type: 'red',
                                });
                            }
                        }
                    }
                }
            }
        });
    };

    return (
        <div>
            <div className="card card-success" style={{ marginTop: '0px' }}>
                <div className="card-header" style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 className="card-title">Error Logs</h3>
                    {/* <div style={{ marginTop: '10px' }}>
                        <button
                            className='btn btn-success btn-default'
                            title='Add Category'
                            data-toggle="modal"
                            data-target="#modal-default">
                            <i className='fa fa-write'></i> New
                        </button>
                    </div> */}
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-3">
                            {/* <button
                                className='btn btn-success btn-sm'
                                title='Add Category'
                                data-toggle="modal"
                                data-target="#modal-default">
                                <i className='fa fa-write'></i> New
                            </button> */}
                        </div>
                    </div>
                    {loading ? (
                        <Spinner /> // Use the Spinner component here
                    ) : (
                        <table id="example1" className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Method</th>
                                    <th>Params</th>
                                    <th>Error</th>
                                    <th>CreatedOn</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {errorLogs.map(error => (
                                    <tr key={error.id}>
                                        <td>{error.class}</td>
                                        <td>{error.method}</td>
                                        <td>{error.params}</td>
                                        <td>{error.error}</td>
                                        <td>{new Date(error.createdOn).toLocaleDateString()}</td>
                                        <td>
                                            <button
                                                className='btn btn-xs btn-danger'
                                                onClick={() => deleteErrorLog(error.id)}
                                                title='Delete'
                                            >
                                                <i className='fa fa-trash'></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Class</th>
                                    <th>Method</th>
                                    <th>Params</th>
                                    <th>Error</th>
                                    <th>CreatedOn</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ErrorLogs;
